import type { FocusedWindow } from '@highlight/common'

export const FOCUSED_WINDOW_TOPIC = 'focused-window.state'

/** GlobalState key: the frontmost window while it is blacklisted (and so absent from the snapshot). */
export const BLACKLISTED_WINDOW_STATE_KEY = 'blacklistedWindow'

export interface FocusedWindowSnapshot {
  revision: number
  focusedWindow?: FocusedWindow
  appIcon?: string
}

export const EMPTY_FOCUSED_WINDOW_SNAPSHOT: FocusedWindowSnapshot = {
  revision: 0,
}
